import Insights from 'mage-insights';

const BASE_EVENT_CATEGORY_BPC = 'generic-onboarding';

type InsightsEventAction = 'click' | 'impression';

interface InsightsEvent {
  category: string;
  action: InsightsEventAction;
  label?: string;
  value?: string;
  customData?: Record<any, any>;
}

export const trackInsightsEvent = (event: InsightsEvent): void => {
  try {
    Insights.event(event);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('There was an error while pushing insights event', err);
  }
};

export enum BPC_INSIGHT_EVENTS {
  APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
  TERMS_AND_CONDITIONS_SUBMITTED = 'TERMS_AND_CONDITIONS_SUBMITTED',
}

export const createBPCInsightEventCategory = (eventType: string): string => {
  return `${BASE_EVENT_CATEGORY_BPC}/${eventType}`;
};
